module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-32.3f879cb8.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-battle-schedule-32.png
// module id = 3181
// module chunks = 11